import faceBookShare from './img/facebook-share.svg';
import imgLink from './img/img-link.svg';

import type { TranslationKey } from '@shared/constants/translations';
import type { HotelReviewSummary } from '@shared/types/hotel-content';
import type { I18nService } from '@shared/types/i18n';
import type { Nullable } from '@shared/types/utils';

import { formatDate } from '@shared/utils-frontend/date-format';
import { CLICK_AREA } from '@shared/utils-frontend/mini-events/constants';
import { isBrowser } from '@shared/utils-universal/is-browser';

const LOCATION_CATEGORY_TYPE = 'RATING_TYPE_LOCATION';
const SHARE_FACEBOOK_URL = 'https://www.facebook.com/sharer.php?u=';
export const SHARE_LINK = {
  FACEBOOK: 'facebook',
  DETAIL: 'detailLink',
};
export const linkImage = imgLink;

export const SHARE_LINK_MAPPING = {
  [SHARE_LINK.FACEBOOK]: CLICK_AREA.DETAIL_FACEBOOK_SHARE,
  [SHARE_LINK.DETAIL]: CLICK_AREA.DETAIL_HOTEL_LINK_SHARE,
};

export const getCurrentUrl = () => {
  if (isBrowser()) {
    return window.location.href;
  }
  return '';
};

export const SHARE_ITEMS: Array<{
  type: string;
  img: string;
  text: TranslationKey;
  url: string;
}> = [
  {
    type: SHARE_LINK.FACEBOOK,
    img: faceBookShare,
    text: 'HotelDetail_label_facebookshare_desc',
    url: `${SHARE_FACEBOOK_URL}${encodeURIComponent(getCurrentUrl())}`,
  },
];

export const appendUTMFlag = (
  url: string,
  platform: string,
  i18n: I18nService,
) => {
  const {
    culture: { locale, market },
  } = i18n;

  const formatLocale = locale.replace('-', '').toLowerCase();
  const date = formatDate(new Date());

  return (
    `${url}?utm_medium=social&utm_content=HotelsDetails` +
    `&utm_source=${platform}` +
    `&utm_campaign=os_${market}_${formatLocale}_${platform}_desktop_HDlink_${date}`
  );
};

export const getLocationReviewSummary = (
  reviewSummary: Nullable<HotelReviewSummary>,
) => {
  if (!reviewSummary) {
    return null;
  }

  return reviewSummary.subratings.find(
    ({ type }) => type === LOCATION_CATEGORY_TYPE,
  );
};

export const getReviewScoreKey = (reviewSummaryScore: number | undefined) => {
  if (reviewSummaryScore) {
    if (reviewSummaryScore >= 5) {
      return 'HotelDetail_map__exceptionalLocation';
    }
    if (reviewSummaryScore >= 4.5) {
      return 'HotelDetail_map__excellentLocation';
    }
    if (reviewSummaryScore >= 4.0) {
      return 'HotelDetail_map__goodLocation';
    }
  }

  return 'Location_label_title';
};
